import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MainLayout from '../../components/layout/MainLayout';
import { useAuth } from '../../contexts/AuthContext';
import BuildIcon from '@mui/icons-material/Build';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

function NotFoundPage() {
  const { authState } = useAuth();
  const { isAuthenticated, user } = authState;
  
  const homePath = isAuthenticated 
    ? (user?.role === 'admin' ? '/admin' : '/dashboard')
    : '/';
  
  return (
    <MainLayout>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 500,
            width: '100%',
            borderRadius: 3,
            backgroundColor: '#f8f9fa'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <BuildIcon sx={{ fontSize: 40, color: '#ffc107', mr: 2 }} />
            <EmojiObjectsIcon sx={{ fontSize: 40, color: '#ffc107' }} />
          </Box>
          
          <Typography variant="h4" color="primary" fontWeight="bold" sx={{ mb: 3, textAlign: 'center' }}>
            We're Building Something Awesome!
          </Typography>
          
          <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem' }} textAlign="center">
            Oops! This page isn't ready yet. Our math wizards are still working their magic!
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            component={RouterLink}
            to={homePath}
            size="large"
            sx={{ 
              borderRadius: 28,
              px: 4,
              py: 1,
              fontSize: '1rem',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
          >
            Back to Math Magic
          </Button>
        </Paper>
      </Box>
    </MainLayout>
  );
}

export default NotFoundPage;